export default {
  createItem: {
    server: '/bims/{bimId}/bimTags',
    method: 'post',
  },
  getList: {
    server: '/bims/{bimId}/bimTags',
    method: 'get',
  },
  updateItem: {
    server: '/bims/{bimId}/bimTags/{bimTagId}',
    method: 'put',
  },
  deleteItem: {
    server: '/bims/{bimId}/bimTags/{bimTagId}',
    method: 'delete',
  },
};
